import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import DrawerFeaturesSection from "./components/DrawerFeaturesSection";
import DrawerForBusinessesSection from "./components/DrawerForBusinessesSection";
import Icon from "../../Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import LanguagePicker from "./LanguagePicker";

import { ButtonAccessability } from "components/Elements/Button/Button.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { UserBrandedHeader } from "./UserBrandedHeader";
import { useState } from "react";

export const HeaderDrawer = ({ isClicked, isShowJumbomailHeader, set }) => {
  const { getTextByKey, getLanguage, getDirection } = useContent();
  const { getSender } = useMail();
  const [showSection, setShowSection] = useState("");

  const userBrandedHeader = getSender() ? getSender().brandedHeader : null;
  const lastUrlSegment = window.location.pathname.split("/").pop();
  let userBrandedDetailsIsEmpty = false;

  if (userBrandedHeader) {
    if (
      Object.keys(userBrandedHeader.ContactDetails).length !== 2 &&
      userBrandedHeader.ContactDetails.constructor === Object &&
      Object.keys(userBrandedHeader.SocialMediaLinks).length === 0 &&
      userBrandedHeader.SocialMediaLinks.constructor === Object
    ) {
      userBrandedDetailsIsEmpty = true;
    }
  }

  return (
    <AnimationContainer
      animationOn={isClicked}
      animationClassName="header-drawer-animation"
      containerElementClassName="header-drawer"
    >
      <div className={`header-drawer-container`}>
        <div className="close-header-drawer-container">
          <Icon
            name="x"
            iconClass="close-header-drawer"
            large
            gray
            onClick={() => {
              set(false);
              document.body.classList.remove("fixed-position");
            }}
          />
        </div>
        {isShowJumbomailHeader || userBrandedDetailsIsEmpty ? (
          <>
            <div className="logo-header-drawer-mobile">
              <LinkToNewTab page="home">
                <Image
                  name="jumbomail-logo-black"
                  title="JUMBOmail"
                  alt="JUMBOmail"
                />
              </LinkToNewTab>
            </div>
            {showSection === "" ? (
              <>
                <LinkToNewTab page="home">
                  {getTextByKey("send-files-now")}
                </LinkToNewTab>
                <div className="expandable-item">
                  <LinkToNewTab
                    page="features"
                    className={
                      lastUrlSegment === "features" ? "active-header" : null
                    }
                  >
                    {getTextByKey("features")}
                  </LinkToNewTab>
                  <ButtonAccessability
                    onClick={() => setShowSection("features")}
                  >
                    <Icon
                      name={
                        getDirection() === "rtl" ? "arrow-left" : "arrow-right"
                      }
                      gray
                      small
                    />
                  </ButtonAccessability>
                </div>
                <div className="expandable-item">
                  <LinkToNewTab page="for-businesses">
                    {getTextByKey("for-businesses")}
                  </LinkToNewTab>
                  <ButtonAccessability
                    onClick={() => setShowSection("for-businesses")}
                  >
                    <Icon
                      name={
                        getDirection() === "rtl" ? "arrow-left" : "arrow-right"
                      }
                      gray
                      small
                    />
                  </ButtonAccessability>
                </div>
                <LinkToNewTab page="plans">
                  {getTextByKey("plans")}
                </LinkToNewTab>
                <hr />
                {(getLanguage() === "en" ||
                  getLanguage() === "es" ||
                  getLanguage() === "it") && (
                  <LinkToNewTab page="blog">
                    {getTextByKey("blog")}
                  </LinkToNewTab>
                )}
                <LinkToNewTab page="support">
                  {getTextByKey("support")}
                </LinkToNewTab>
                <LinkToNewTab page="contact-us">
                  {getTextByKey("contact-us")}
                </LinkToNewTab>
                <hr />
              </>
            ) : null}
            {showSection === "features" ? (
              <DrawerFeaturesSection
                setShowSection={setShowSection}
                setShowHeaderDrawer={set}
              />
            ) : null}
            {showSection === "for-businesses" ? (
              <DrawerForBusinessesSection setShowSection={setShowSection} />
            ) : null}
          </>
        ) : (
          <UserBrandedHeader isHeadDraw={true} />
        )}

        {showSection === "" ? (
          <div className="expandable-item">
            <LanguagePicker withLabel />
            <ButtonAccessability>
              <Icon
                name={getDirection() === "rtl" ? "arrow-left" : "arrow-right"}
                gray
                small
                iconClass="drawer-arrow-right"
              />
            </ButtonAccessability>
          </div>
        ) : null}
        {isShowJumbomailHeader || userBrandedDetailsIsEmpty ? (
          <></>
        ) : (
          <>
            <LinkToNewTab page="home">
              <div className="jumbomail-home-button">
                <Icon
                  name={"jumbomail-logo-small"}
                  medium
                  clickable
                  white={false}
                  title="JUMBOmail"
                  alt="JUMBOmail"
                />
                {getTextByKey("jumbomail-home")}
              </div>
            </LinkToNewTab>
          </>
        )}
      </div>
    </AnimationContainer>
  );
};
